class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (!input) return;
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value, 10);
    const index = event.target.dataset.index;
    let message = '';

    // 0 = remove (vietoj klaidos traktuojam kaip šiukšliadėžę)
    if (inputValue === 0) {
      event.target.setCustomValidity('');
      event.target.reportValidity();

      this.updateQuantity(
        index,
        0,
        event,
        document.activeElement && document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );

      return;
    }

    const min = parseInt(event.target.dataset.min || event.target.min || '1', 10);
    const max = event.target.max ? parseInt(event.target.max, 10) : null;
    const step = event.target.step ? parseInt(event.target.step, 10) : 1;

    if (inputValue < min) {
      if (window.quickOrderListStrings && window.quickOrderListStrings.min_error) {
        message = window.quickOrderListStrings.min_error.replace('[min]', min);
      }
    } else if (max !== null && inputValue > max) {
      if (window.quickOrderListStrings && window.quickOrderListStrings.max_error) {
        message = window.quickOrderListStrings.max_error.replace('[max]', max);
      }
    } else if (inputValue % step !== 0) {
      if (window.quickOrderListStrings && window.quickOrderListStrings.step_error) {
        message = window.quickOrderListStrings.step_error.replace('[step]', step);
      }
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement && document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    // 🔹 Cart drawer (šoninis krepšelis)
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // Ką perrenderinam iš serverio:
          // 1) <cart-drawer-items>  – produktų sąrašas
          // 2) .cart-drawer__footer – estimated total, taxes tekstas
          // 3) .cart__ctas          – Checkout mygtukas su nauja suma
          const selectors = [
            'cart-drawer-items',
            '.cart-drawer__footer',
            '.cart__ctas'
          ];

          selectors.forEach((selector) => {
            const sourceElement = html.querySelector(selector);
            const targetElement = document.querySelector(selector);

            if (!sourceElement || !targetElement) return;

            // Produktų sąrašui – innerHTML, kad neišmestų pačio <cart-drawer-items> elemento
            if (selector === 'cart-drawer-items') {
              targetElement.innerHTML = sourceElement.innerHTML;
            } else {
              // footer + CTAs – pilnas replace, kad turėtum naują sumą ir tekstą
              targetElement.replaceWith(sourceElement);
            }
          });

          // Signalas visiems, kad krepšelis atnaujintas
          document.dispatchEvent(new Event('cart:updated'));
        })
        .catch((e) => console.error(e));
    }

    // 🔹 Desktop krepšelis (default Shopify logika)
    return fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        if (!sourceQty) return;

        this.innerHTML = sourceQty.innerHTML;

        // Signalas visiems, kad krepšelis atnaujintas
        document.dispatchEvent(new Event('cart:updated'));
      })
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

updateQuantity(line, quantity, event, name, variantId) {
  this.enableLoading(line);

  const baseSections = this.getSectionsToRender().map((section) => section.section);

  const body = JSON.stringify({
    line,
    quantity,
    sections: baseSections,
    sections_url: window.location.pathname,
  });

  const eventTarget =
    event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.text())
    .then((state) => {
      let parsedState = JSON.parse(state);

      // ---- Shipping protection guard: jei po šito change liko tik SP, darom ANTRĄ change, kuris jį nuima ----
      const cartDrawerEl = document.querySelector('cart-drawer');
      const spHandle = cartDrawerEl && cartDrawerEl.dataset.spHandle;

      const hasOnlySp =
        !!spHandle &&
        Array.isArray(parsedState.items) &&
        parsedState.items.length === 1 &&
        parsedState.items[0].handle === spHandle;

      if (!hasOnlySp) {
        // normalus scenarijus – grąžinam šitą state
        return parsedState;
      }

      // Čia jau cart'e realiai yra tik SP – darom antrą /cart/change:
      // line: 1, quantity: 0, su tais pačiais sections,
      // ir UI atnaujinsim pagal ŠITĄ, jau tuščią, state.
      const clearSpBody = JSON.stringify({
        line: 1,
        quantity: 0,
        sections: baseSections,
        sections_url: window.location.pathname,
      });

      return fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body: clearSpBody,
      })
        .then((response2) => response2.text())
        .then((state2) => {
          try {
            return JSON.parse(state2);
          } catch (e) {
            console.error('SP second change parse error', e);
            return parsedState; // fallback – kad nekiltų errorų
          }
        })
        .catch((err) => {
          console.error('SP auto-clear error', err);
          return parsedState; // fallback
        });
    })
    .then((parsedState) => {
      // Nuo čia – tavo likęs originalus Dawn logikos blokas,
      // tik naudojam jau GALUTINĮ parsedState (tuščią arba normalų).
      CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = '';
        if (
          items.length === parsedState.items.length &&
          quantityElement &&
          updatedValue !== parseInt(quantityElement.value, 10)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const cartDrawerWrapper2 = document.querySelector('cart-drawer');
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper2
            ? trapFocus(
                cartDrawerWrapper2,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper2) {
          trapFocus(
            cartDrawerWrapper2.querySelector('.drawer__inner-empty'),
            cartDrawerWrapper2.querySelector('a')
          );
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper2) {
          trapFocus(
            cartDrawerWrapper2,
            document.querySelector('.cart-item__name')
          );
        }
      });

      CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-items',
        cartData: parsedState,
        variantId: variantId,
      });
    })
    .catch(() => {
      this.querySelectorAll('.loading__spinner')
        .forEach((overlay) => overlay.classList.add('hidden'));
      const errors =
        document.getElementById('cart-errors') ||
        document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    });
}

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden')
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Shipping protection toggle – max 1 vnt ir su loading lock
document.addEventListener('change', function (e) {
  const checkbox = e.target.closest('.js-shipping-protection-toggle');
  if (!checkbox) return;

  const variantId = checkbox.dataset.variant;
  if (!variantId) return;

  // jeigu jau vyksta request – ignoruojam
  if (checkbox.dataset.loading === 'true') {
    e.preventDefault();
    return;
  }

  const add = checkbox.checked;

  // absoliuti quantity – ne "add 1", o "set to 1/0"
  const url = '/cart/update.js';
  const updates = {};
  updates[variantId] = add ? 1 : 0;

  const payload = { updates };

  // checkout dots
  const checkoutBtn = document.getElementById('CartDrawer-Checkout');

  // lock UI
  checkbox.dataset.loading = 'true';
  checkbox.disabled = true;
  if (checkoutBtn) {
    checkoutBtn.classList.add('loading');
  }

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then(function () {
      const drawerItems = document.querySelector('cart-drawer-items');
      if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
        return drawerItems.onCartUpdate();
      } else {
        window.location.reload();
      }
    })
    .catch(function (err) {
      console.error(err);
    })
    .finally(function () {
      // po perrenderinimo DOM'e bus naujas checkbox – jį ir atrakinam
      const newCheckbox = document.querySelector('.js-shipping-protection-toggle');
      if (newCheckbox) {
        newCheckbox.dataset.loading = 'false';
        newCheckbox.disabled = false;
      }
      // checkout mygtukas po perrenderinimo vis tiek bus be "loading" klasės,
      // bet jei dėl kokios nors priežasties neperrenderino – nuimam ranka
      const newCheckoutBtn = document.getElementById('CartDrawer-Checkout');
      if (newCheckoutBtn) {
        newCheckoutBtn.classList.remove('loading');
      }
    });
});
